import { Analytics, getScreenFromUrl } from '@trello/atlassian-analytics';
import { getChannel } from './getChannel';
import { getSessionId } from './getSessionId';
import { isBrowserSupported } from '@trello/browser';
import { sendErrorEvent } from './sendErrorEvent';

interface CrashEvent {
  // the JS error object (for Sentry purposes only)
  error: Error;
  // a map of tag/value pairs to send along with the entry
  attributes?: { [key: string]: boolean | string };
}

/**
 * Sends a crash metric (operational event) via our analytics client
 * and also sends the error along to our Sentry endpoint
 */
export const sendCrashEvent = async (crashEvent: CrashEvent) => {
  const source = getScreenFromUrl(new URL(window.location.href));
  const channel = await getChannel();

  Analytics.sendOperationalEvent({
    source,
    action: 'crashed',
    actionSubject: 'app',
    attributes: {
      trelloSessionId: getSessionId(),
      channel,
      isBrowserSupported: isBrowserSupported(),
    },
  });

  sendErrorEvent(crashEvent);
};
